import AnimateBehaviour from "ags/behaviours/ags-animate-behaviour";
import bigWinBounceText from "ags/components/big-win-bounce-text";
import { JackpotTiers } from "ags/names";
import AGSInit from "ags/states/ags-init";
import mcRewardAnimation from "components/mc-reward-animation";
import CGJackpotValuesControl from "controls/cg-jackpot-values-control";
import Components from "slotworks/components/components";
import BoxDimSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/box-dim-symbol-behaviour";
import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";
import ControlList from "slotworks/smart-ui/control-list";
import smartUiManager from "slotworks/smart-ui/smart-ui-manager";
import bonusSymbolSetup from "utils/bonus-symbol-setup";
import lightningBorderAnimationUtil from "utils/lightning-border-animation-util";
import { LLCustomLayers } from "names";
import Gameplay from "slotworks/model/gameplay/gameplay";
import symbolSubstituteSupplement from "integration/builders/suppliments/symbol-substitute-supplement";
import reelsetModifier from "utils/reelset-modifier";
import substituteSymbols from "utils/substitute-symbols";
import CGCelebrateWinComponent from "components/cg-celebrate-win-component";
import SpinReelTransition from "slotworks/components/matrix/reel/transition-behaviours/spin/spin-reel-transition";
import MCSymbolBorderAnimationBehaviour from "components/matrix/symbol/behaviours/mc-symbol-border-behaviour";
import AGSRollUp from "ags/states/ags-roll-up";
import LightningBorderLoopWinsMediator from "mediators/lightning-border-loop-wins-mediator";
import { ZoomSymbolBehaviour } from "ags/behaviours/zoom-symbol-behaviour";
import AnimateWinsMediator from "ags/mediators/animate-wins-mediator";

export default class CGInit extends AGSInit {

    public onEnter() {
        BoxDimSymbolBehaviour.opacity = 0.92;
        BoxDimSymbolBehaviour.color = 0x000815;
        bonusSymbolSetup.setupGraphics();
        substituteSymbols.generateDimImages();
        super.onEnter();
    }

    protected setupGameComponents() {

        // Layer order
        Layers.MenusContent.moveBehind(Layers.Prompts);

        Layers.Custom.get(LLCustomLayers.MONEY_CHARGE_BONUS_SYMBOLS).hide();
        Layers.Footer.moveAbove(Layers.BetBar);
        Layers.Custom.get(LLCustomLayers.HOLD_AND_SPIN_BORDER).moveAbove(Layers.Custom.get(LLCustomLayers.JACKPOTS));
        Layers.Custom.get(LLCustomLayers.VAULT_GATEWAY).moveAbove(Layers.MatrixForeground);
        Layers.Custom.get(LLCustomLayers.LOGOS).moveAbove(Layers.Custom.get(LLCustomLayers.VAULT_GATEWAY));
        Layers.Header.moveBehind(Layers.MenusContent);

        // Symbol behaviours
        const listOfAnimatingSymbols = ["WW", "H1", "H2", "H3", "H4", "H5", "L1", "L2", "BN", "TT", "WW_BN"];
        const zoomSymbols = ["L3", "L4", "L5", "L6"];

        Components.matrix.addDefaultSymbolBehaviour(AnimateBehaviour, listOfAnimatingSymbols);
        Components.matrix.addDefaultSymbolBehaviour(ZoomSymbolBehaviour, zoomSymbols);
        Components.matrix.addDefaultSymbolBehaviour(BoxDimSymbolBehaviour, listOfAnimatingSymbols.concat(zoomSymbols));

        Components.celebrateWin = new CGCelebrateWinComponent();

        ControlList.addControlList(new ControlList<CGJackpotValuesControl>(CGJackpotValuesControl, "jackpots_text_", [
            JackpotTiers.MINI,
            JackpotTiers.MINOR,
            JackpotTiers.MAJOR,
            JackpotTiers.GRAND
        ]));

        const layer = Layers.Custom.get(LLCustomLayers.JACKPOTS);
        const defaultGroup = smartUiManager.newSmartUIGroup(layer, "default");
        smartUiManager.newSmartUIGroup(layer, "bonus_tally");

        smartUiManager.showGroup(defaultGroup).execute();

        lightningBorderAnimationUtil.useBaseLightningBorder();
        mcRewardAnimation.setup();
        bigWinBounceText.init();
        reelsetModifier.init();

        SpinReelTransition.allowAnticipationSkips = false;

        // Sound event
        Services.sound.event(SoundEvent.game_inactive);

        AGSRollUp.animateWinsMediatorType = LightningBorderLoopWinsMediator;
        AnimateWinsMediator.alternateAnimation = false;

        Gameplay.dataProcessorSupplements.addBeforeStandard(symbolSubstituteSupplement);

        super.setupGameComponents();
    }
}
